export const phoneMaksInAlpha3 = {
  ASC: ['####'],
  AND: ['###-###'],
  ARE: ['##-###-####', '#-###-####'],
  AFG: ['##-###-####'],
  ATG: ['(###) ###-####'],
  AIA: ['(###) ###-####'],
  ALB: ['(###) ###-###'],
  ARM: ['##-###-###'],
  ANT: ['###-####', '###-####', '####-####'],
  AGO: ['(###) ###-###'],
  ATA: ['###-###'],
  ARG: ['(###) ###-####'],
  ASM: ['(###) ###-####'],
  AUT: ['(###) ###-####'],
  AUS: ['#-####-####'],
  ABW: ['###-####'],
  AZE: ['##-###-##-##'],
  BIH: ['##-#####', '##-####'],
  BRB: ['(###) ###-####'],
  BGD: ['##-###-###'],
  BEL: ['(###) ###-###'],
  BFA: ['##-##-####'],
  BGR: ['(###) ###-###'],
  BHR: ['####-####'],
  BDI: ['##-##-####'],
  BEN: ['##-##-####'],
  BMU: ['(###) ###-####'],
  BRN: ['###-####'],
  BOL: ['#-###-####'],
  BRA: ['(##) ####-####', '(##) ####-####', '(##) #####-####'],
  BHS: ['(###) ###-####'],
  BTN: ['##-###-###', '#-###-###'],
  BWA: ['##-###-###'],
  BLR: ['(##) ###-##-##'],
  BLZ: ['###-####'],
  CAN: ['(###) ###-####'],
  COD: ['(###) ###-###'],
  CAF: ['##-##-####'],
  COG: ['##-###-####'],
  CHE: ['##-###-####'],
  CIV: ['##-###-###'],
  COK: ['##-###'],
  CHL: ['#-####-####'],
  CMR: ['####-####'],
  CHN: ['(###) ####-####', '(###) ####-###', '##-#####-#####'],
  COL: ['(###) ###-####'],
  CRI: ['####-####'],
  CUB: ['#-###-####'],
  CPV: ['(###) ##-##'],
  CUW: ['###-####'],
  CYP: ['##-###-###'],
  CZE: ['(###) ###-###'],
  DEU: [
    '(####) ###-####',
    '(###) ###-####',
    '(###) ##-####',
    '(###) ##-###',
    '(###) ##-##',
    '###-###',
  ],
  DJI: ['##-##-##-##'],
  DNK: ['##-##-##-##'],
  DMA: ['(###) ###-####'],
  DOM: ['(###) ###-####', '(###) ###-####', '(###) ###-####'],
  DZA: ['##-###-####'],
  ECU: ['##-###-####', '#-###-####'],
  EST: ['####-####', '###-####'],
  EGY: ['(###) ###-####'],
  ERI: ['#-###-###'],
  ESP: ['(###) ###-###'],
  ETH: ['##-###-####'],
  FIN: ['(###) ###-##-##'],
  FJI: ['##-#####'],
  FLK: ['#####'],
  FSM: ['###-####'],
  FRO: ['###-###'],
  FRA: ['#####-####', '(###) ###-###', '##-####', '(###) ###-###'],
  GAB: ['#-##-##-##'],
  GRD: ['(#######-####'],
  GEO: ['(###) ###-###'],
  GUF: ['#####-####'],
  GHA: ['(###) ###-###'],
  GIB: ['###-#####'],
  GRL: ['##-##-##'],
  GMB: ['(###) ##-##'],
  GIN: ['##-###-###'],
  GNQ: ['##-###-####'],
  GRC: ['(###) ###-####'],
  GTM: ['#-###-####'],
  GUM: ['(###) ###-####'],
  GNB: ['#-######'],
  GUY: ['###-####'],
  HKG: ['####-####'],
  HND: ['####-####'],
  HRV: ['##-###-###'],
  HTI: ['##-##-####'],
  HUN: ['(###) ###-###'],
  IDN: [
    '(###) ###-####',
    '##-###-##',
    '##-###-###',
    '##-###-####',
    '(###) ###-###',
    '(###) ###-##-###',
  ],
  IRL: ['(###) ###-###'],
  ISR: ['##-###-####', '#-###-####'],
  IND: ['(####) ###-###'],
  IOT: ['###-####'],
  IRQ: ['(###) ###-####'],
  IRN: ['(###) ###-####'],
  ISL: ['###-####'],
  ITA: ['(###) ####-###'],
  JAM: ['(###) ###-####'],
  JOR: ['#-####-####'],
  JPN: ['##-####-####', '(###) ###-###'],
  KEN: ['###-######'],
  KGZ: ['(###) ###-###'],
  KHM: ['##-###-###'],
  KIR: ['##-###'],
  COM: ['##-#####'],
  KNA: ['(###) ###-####'],
  PRK: [
    '###-###-####',
    '##-###-###',
    '###-####-###',
    '###-###',
    '####-####',
    '####-#############',
  ],
  KOR: ['##-###-####'],
  KWT: ['####-####'],
  CYM: ['(###) ###-####'],
  KAZ: ['(###) ###-##-##', '(###) ###-##-##'],
  LAO: ['(####) ###-###', '##-###-###'],
  LBN: ['##-###-###', '#-###-###'],
  LCA: ['(###) ###-####'],
  LIE: ['(###) ###-####'],
  LKA: ['##-###-####'],
  LBR: ['##-###-###'],
  LSO: ['#-###-####'],
  LTU: ['(###) ##-###'],
  LUX: ['(###) ###-###'],
  LVA: ['##-###-###'],
  LBY: ['##-###-###'],
  MAR: ['##-####-###'],
  MCO: ['(###) ###-###', '##-###-###'],
  MDA: ['####-####'],
  MNE: ['##-###-###'],
  MDG: ['##-##-#####'],
  MHL: ['###-####'],
  MKD: ['##-###-###'],
  MLI: ['##-##-####'],
  MMR: ['##-###-###', '#-###-###', '###-###'],
  MNG: ['##-##-####'],
  MAC: ['####-####'],
  MNP: ['(###) ###-####'],
  MTQ: ['(###) ##-##-##'],
  MRT: ['##-##-####'],
  MSR: ['(###) ###-####'],
  MLT: ['####-####'],
  MUS: ['###-####'],
  MDV: ['###-####'],
  MWI: ['#-###-###', '#-####-####'],
  MEX: ['(###) ###-####', '##-##-####'],
  MYS: ['##-###-####', '(###) ###-###', '##-###-###', '#-###-###'],
  MOZ: ['##-###-###'],
  NAM: ['##-###-####'],
  NCL: ['##-####'],
  NER: ['##-##-####'],
  NFK: ['###-###'],
  NGA: ['(###) ###-####', '##-###-###', '##-###-##', '(###) ###-####'],
  NIC: ['####-####'],
  NLD: ['##-###-####'],
  NOR: ['(###) ##-###'],
  NPL: ['##-###-###'],
  NRU: ['###-####'],
  NIU: ['####'],
  NZL: ['(###) ###-###', '##-###-###', '(###) ###-####'],
  OMN: ['##-###-###'],
  PAN: ['###-####'],
  PER: ['(###) ###-###'],
  PYF: ['##-##-##'],
  PNG: ['(###) ##-###'],
  PHL: ['(###) ###-####'],
  PAK: ['(###) ###-####'],
  POL: ['(###) ###-###'],
  PSE: ['##-###-####'],
  PRT: ['##-###-####'],
  PLW: ['###-####'],
  PRY: ['(###) ###-###'],
  QAT: ['####-####'],
  REU: ['#####-####'],
  ROU: ['##-###-####'],
  SRB: ['##-###-####'],
  RUS: ['(###) ###-##-##'],
  RWA: ['(###) ###-###'],
  SAU: ['#-###-####'],
  SLB: ['###-####', '#####'],
  SYC: ['#-###-###'],
  SDN: ['##-###-####'],
  SWE: ['##-###-####'],
  SGP: ['####-####'],
  SHN: ['####', '####'],
  SVN: ['##-###-###'],
  SVK: ['(###) ###-###'],
  SLE: ['##-######'],
  SMR: ['####-######'],
  SEN: ['##-###-####'],
  SOM: ['##-###-###', '#-###-###', '#-###-###'],
  SUR: ['###-####', '###-###'],
  SSD: ['##-###-####'],
  STP: ['##-#####'],
  SLV: ['##-##-####'],
  SXM: ['(###) ###-####'],
  SYR: ['##-####-###'],
  SWZ: ['##-##-####'],
  TCA: ['(###) ###-####'],
  TCD: ['##-##-##-##'],
  TGO: ['##-###-###'],
  THA: ['##-###-####', '##-###-###'],
  TJK: ['##-###-####'],
  TKL: ['####'],
  TLS: ['###-####', '###-#####'],
  TKM: ['#-###-####'],
  TUN: ['##-###-###'],
  TON: ['#####'],
  TUR: ['(###) ###-####'],
  TTO: ['(###) ###-####'],
  TUV: ['######', '#####'],
  TWN: ['#-####-####', '####-####'],
  TZA: ['##-###-####'],
  UKR: ['(##) ###-##-##'],
  UGA: ['(###) ###-###'],
  USA: ['(###) ###-####'],
  URY: ['#-###-##-##'],
  UZB: ['##-###-####'],
  VAT: ['#-###-#####'],
  VCT: ['(###) ###-####'],
  VEN: ['(###) ###-####'],
  VGB: ['(###) ###-####'],
  VIR: ['(###) ###-####'],
  VNM: ['##-####-###', '(###) ####-###'],
  VUT: ['##-#####', '#####'],
  WLF: ['##-####'],
  WSM: ['##-####'],
  YEM: ['###-###-###', '#-###-###', '##-###-###'],
  ZAF: ['##-###-####'],
  ZMB: ['##-###-####'],
  ZWE: ['#-######'],
};
